/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tab } from 'semantic-ui-react'

import Service from './Service'
import Order from './Order'
import Report from './Report'
import Reason from './Reason'
import Driver from './Driver'

import utils from '../../utils'

import DriverActions from '../../reducers/driverReducer'

class Configurations extends Component {
  componentDidMount() {
    const { fetchTimeSlot, readyToPickUpLoaded } = this.props

    if (!readyToPickUpLoaded) fetchTimeSlot()
  }

  onTabChange = index => {
    const { history } = this.props
    const tabs = Object.keys(this.tabPanes())
    const queryString = tabs[index] ? `?tab=${tabs[index]}` : ''

    history.push(`/configurations${queryString}`)
  }

  tabPanes = () => {
    const { user, roles, regions } = this.props

    const panes = {
      'order': {
        menuItem: 'Order',
        render: () => <Order regions={regions} />
      },
      'reason': {
        menuItem: 'Reason', render: () => <Reason />
      },
    }

    if (roles[user.role] && (roles[user.role].name === 'Super Admin' || roles[user.role].name === 'Admin')) {
      panes.service = { menuItem: 'Service', render: () => <Service regions={regions} /> }
      panes.report = { menuItem: 'Report', render: () => <Report /> }
      panes.drivers = { menuItem: 'Driver', render: () => <Driver /> }
    }

    return panes
  }

  render() {
    const params = utils.helpers.urlParams()
    const tab = params.tab || 'order'
    const tabIndex = Object.keys(this.tabPanes()).indexOf(tab)

    return (
      <div>
        <Tab
          activeIndex={tabIndex}
          menu={{ pointing: true }}
          panes={Object.values(this.tabPanes())}
          onTabChange={(e, { activeIndex }) => this.onTabChange(activeIndex)}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ auth, rolePermission, regions, drivers }) => ({
  user: auth.data,
  regions: regions.data,
  roles: rolePermission.roles,
  readyToPickUpLoaded: drivers.readyToPickUpLoaded,
})

const mapDispatch = {
  fetchTimeSlot: DriverActions.fetchTimeSlot,
}

export default connect(
  mapStateToProps,
  mapDispatch
)(Configurations)



// WEBPACK FOOTER //
// ./src/containers/configurations/index.js